import React from 'react';
import { IoTicketOutline } from 'react-icons/io5';

/**
 * TicketIcon
 * Ikona vstupenky na označenie sekcií súvisiacich s lístkami.
 */
const TicketIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <IoTicketOutline className={className} {...props} />
);

export default TicketIcon;

